<div
  *ngIf="tickerItems().length"
  #tickerContainerRef
  class="carrier-ticker__viewport"
  [class.carrier-ticker__viewport--animated]="shouldLoopTicker() && !isTickerInteracting()"
  aria-label="Carrier weighted premium ticker"
  tabindex="0"
  (scroll)="handleTickerScroll()"
  (mouseenter)="pauseTicker()"
  (mouseleave)="resumeTicker()"
  (focusin)="pauseTicker()"
  (focusout)="resumeTicker()"
>
  <div #tickerTrackRef class="carrier-ticker__track" [style.animation-delay.ms]="tickerAnimationDelayMs()">
    <div #tickerSegmentRef class="carrier-ticker__segment">
      <div class="carrier-ticker__item" *ngFor="let tickerItem of tickerItems()">
        <ng-container *ngIf="tickerItem.imageUrl && !isBrokenCarrierImage(tickerItem.imageUrl); else tickerDot">
          <img
            class="carrier-ticker__image"
            [src]="tickerItem.imageUrl"
            [alt]="tickerItem.name + ' logo'"
            loading="lazy"
            (error)="handleCarrierImageError(tickerItem.imageUrl)"
          />
        </ng-container>
        <ng-template #tickerDot>
          <span class="carrier-ticker__dot" [style.background]="tickerItem.color" aria-hidden="true"></span>
        </ng-template>
        <span class="carrier-ticker__name">{{ tickerItem.name }}</span>
        <span class="carrier-ticker__premium">{{ formatPremiumTotal(tickerItem.premiumTotal) }}</span>
        <span class="carrier-ticker__share">{{ tickerItem.share | percent: "1.1-1" }}</span>
      </div>
    </div>

    <div *ngIf="shouldLoopTicker()" class="carrier-ticker__segment" aria-hidden="true">
      <div class="carrier-ticker__item" *ngFor="let tickerItem of tickerItems()">
        <ng-container
          *ngIf="tickerItem.imageUrl && !isBrokenCarrierImage(tickerItem.imageUrl); else tickerDotDuplicate"
        >
          <img
            class="carrier-ticker__image"
            [src]="tickerItem.imageUrl"
            alt=""
            loading="lazy"
            (error)="handleCarrierImageError(tickerItem.imageUrl)"
          />
        </ng-container>
        <ng-template #tickerDotDuplicate>
          <span class="carrier-ticker__dot" [style.background]="tickerItem.color" aria-hidden="true"></span>
        </ng-template>
        <span class="carrier-ticker__name">{{ tickerItem.name }}</span>
        <span class="carrier-ticker__premium">{{ formatPremiumTotal(tickerItem.premiumTotal) }}</span>
        <span class="carrier-ticker__share">{{ tickerItem.share | percent: "1.1-1" }}</span>
      </div>
    </div>
  </div>
</div>
